module.exports = __webpack_public_path__ + "static/img/WebMaintainance.d976467.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WebMaintainance.svg
// module id = MSNN
// module chunks = 1